import {
  NEWS_FAVOURITE_TYPE,
} from '@domain/features/user-favourites/user-favourites-feature'
import { useUserFavourite } from '@presentation/hooks/useUserFavourite'

export function useNewsFavourite(activityId: string | undefined) {
  return useUserFavourite(activityId, NEWS_FAVOURITE_TYPE)
}
